import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {candidate_template} from "../components/templates/candidate_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {about_template} from "../components/templates/about_template";

declare var ko: any;
declare var page: any;

export class about extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected aboutPage: about_template;

    protected getModuleName(){

        return "about";
    }

    buildContent() : Array<Element>{

        this.aboutPage = new about_template("aboutPage", this.viewModel, this);
        return [this.aboutPage.build()];
    }

    public fillPage() : void{

        this.filterList();
    }

    protected filterList() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        //this.loadingIn(this.aboutPage.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand +'/ideation/topics2/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.aboutPage.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                //let responseParsed = JSON.parse(req.request.response);
                //obj.updateList(responseParsed);
            });
            //obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/about.ts